import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { exists } from 'src/app/functions/exists';
import { BaseComponent } from 'src/app/models/base/base-component';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';
import { SectionColumnViewModel } from 'src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { SectionRowViewModel } from 'src/app/modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';

@Component({
  selector: 'app-handle-badge-mode',
  templateUrl: './handle-badge-mode.component.html',
  styleUrls: ['./handle-badge-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HandleBadgeModeComponent extends BaseComponent {
  @Input({ required: true }) colVm: SectionColumnViewModel;
  @Input({ required: true }) rowVm: SectionRowViewModel;
  @Input() nonListColumnBadgeAsset: BadgeAsset | undefined;
  @Input() listColumnBadgeAsset: BadgeAsset | undefined;
  setupViews() {}
  setupBindings() {}
  isBadgeModeAndBadgeAssetExists() {
    return (
      this.colVm.columnConfigDataValueIsBadgeMode() &&
      (exists(this.nonListColumnBadgeAsset) || exists(this.listColumnBadgeAsset))
    );
  }
}
